/**
*@title main
*@date 21-07-30
*@author 홍수희, 박지훈, 권윤성
*@desc route
*@etc(change)
*/
import React, { useState, useEffect } from 'react'
import { Route, Router, Switch, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import main from './main/Main.js';
import direction_map from './main/Directions.js';
import direction_hotel from './main/direction/hotel.jsx';
import direction_shuttle from './main/direction/shuttle.js';

import FloatingButton from "./Components/Button/FloatingButton";

import about_guide from './main/about/guide.js';
import about_seminar from './main/about/seminar.js';
import about_symposium from './main/about/symposium.js';
import about_industrialseminar from './main/about/industrialseminar.jsx';
import about_event from './main/about/event.js';
import about_schedule from './main/about/schedule.js';
import about_nobel from './main/about/nobel.js';
import about_forum from './main/about/forum.js';

import exhibitor_company from './main/exhibitor/company.jsx';
import exhibitor_boothmap from './main/exhibitor/booth.jsx';
import exhibitor_contact from './main/exhibitor/contact.js';
import exhibitor_venture_captial from './main/exhibitor/venture.js';
import exhibitor_companysponsor from './main/exhibitor/companysponsor';

import visitor_guide from './main/visitor/guide.js';
import visitor_registration from './main/visitor/registration.js';
import visitor_boothmap from './main/visitor/booth.jsx';
import visitor_check_registration from './main/visitor/check_registration.js';

import info_notice from './main/info/notice.js';
import info_FAQ from './main/info/FAQ';
import info_press from './main/info/press.js';
import info_gallery from './main/info/gallery.js';

import NavBar from './Components/NavBar/NavBar.jsx';

function App(){
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    window.addEventListener('resize', () => { 
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
    })
    
    return(
        <div className="app">
            <NavBar />
            <FloatingButton />
            <Switch>
                <Route path="/" component={main} exact={true}/>
                {/* About */}
                <Route path="/about/guide" component={about_guide} exact={true}/>
                <Route path="/about/schedule" component={about_schedule} exact={true}/>
                <Route path="/about/seminar" component={about_seminar} exact={true}/>
                <Route path="/about/symposium" component={about_symposium} exact={true}/>
                <Route path="/about/industrialseminar" component={about_industrialseminar} exact={true}/>
                <Route path="/about/event" component={about_event} exact={true}/>
                <Route path="/about/nobel" component={about_nobel} exact={true}/>
                <Route path="/about/forum" component={about_forum} exact={true}/>
                
                {/* Exhibitor */}
                <Route path="/exhibitor/company" component={exhibitor_company} exact={true}/>
                <Route path="/exhibitor/boothmap" component={exhibitor_boothmap} exact={true}/>
                <Route path="/exhibitor/overview" component={exhibitor_contact} exact={true}/>
                <Route path="/exhibitor/companysponsor" component={exhibitor_companysponsor} exact={true}/>
                <Route path="/exhibitor/venture_capital" component={exhibitor_venture_captial} exact={true}/>
                
                {/* Visitor */}
                <Route path="/visitor/guide" component={visitor_guide} exact={true}/>
                <Route path="/visitor/registration" component={visitor_registration} exact={true}/>
                <Route path="/visitor/boothmap" component={visitor_boothmap} exact={true}/>
                <Route path="/visitor/check_registration" component={visitor_check_registration} exact={true}/>
                
                {/* Info */}
                <Route path="/info/notice" component={info_notice} exact={true}/>
                <Route path="/info/FAQ" component={info_FAQ} exact={true} />
                <Route path="/info/press" component={info_press} exact={true}/>
                <Route path="/info/gallery" component={info_gallery} exact={true}/>
                
                {/* Directions */}
                <Route path="/directions/map" component={direction_map} exact={true}/>
                <Route path="/directions/hotel" component={direction_hotel} exact={true}/>
                <Route path="/directions/bus" component={direction_shuttle} exact={true}/>
            </Switch>
        </div>
    )
}

export default App;
